export function hxConfirm(evt, el) {
	if (!evt.detail) {
		console.log('not found', evt)
		return
	}

	evt.preventDefault()
	console.log(`hxConfirm: ${Object.keys(el.dataset)}`)
	// evt.detail.issueRequest()
}
